<template>
    <div class="time_container">
      <div class="select_time">
        <span>Выполнять</span>
        <select v-model="scheduleType">
          <option value="default" v-if="!disableDefaultTask || isDefaultTask">Как основную задачу</option>
          <option value="oneshot" v-if="allowOneShot">До конца плейлиста</option>
          <option value="interval">Задать длительность</option>
        </select>
      </div>
      <div v-if="scheduleType != 'default'" class="select_time">
        <span>Повторять</span>
        <div style='display: flex; padding: 0;'>
        <select v-model="repeatMode" style='flex-grow: 1; min-width: 60%;'>
          <option value="daily">Раз в сутки</option>
          <option value="periodic">Каждыe N минут</option>
        </select>
        <input type="number" v-show="repeatMode == 'periodic'" v-model='repeatRate' style='flex-grow: 1; min-width: auto;' />
        </div>
      </div>
      <div v-if="scheduleType != 'default'" class="select_time">
          <div>
              <span>Начало в</span>
          </div>
        <input type="time" v-model="startTime" :class="{'is-invalid': startTimeIsInvalid}" />
      </div>
      <div v-if="scheduleType == 'interval'" class="select_time">
          <div>
              <span v-if="repeatMode == 'daily'">Конец в</span>
              <span v-else>Продолжительность мин.</span>
          </div>
        <input v-if="repeatMode == 'daily'" type="time" v-model="endTime" />
        <input v-else min="0"  v-model="scheduleDuration" />
      </div>
      
    </div>
  </template>
  
  <script>
  import {
    DailyTime,
    DefaultSchedule,
    PlayUntilCompleted,
    PlayUntilTime,
    PeriodicTime,
    Task
  } from '@/api/ScheduleModel'
  
  export default {
      props: {
          task: Object,
          disableDefaultTask: Boolean,
          allowOneShot: Boolean,
          tDuration: Number
      },
      data: function(){
          return {
              startTimeIsInvalid: false,
          }
      },
      computed: {
          isDefaultTask: function(){
              return this.task.schedule instanceof DefaultSchedule;
          },
          scheduleDuration: {
            get(){
                if (isNaN(this.task.schedule.duration)){
                    return this.task.schedule.duration = 0;
                }else{
                    return this.task.schedule.duration
                }
            },
            set(newVal){
                this.task.schedule.duration = parseInt(newVal);
            }
          },
          scheduleType: {
              get() {
                  if(!(this.task instanceof Task)) return null;
                  if(this.task.schedule instanceof DefaultSchedule) {
                      return 'default';
                  } else if(this.task.schedule instanceof PlayUntilCompleted || (this.task.schedule instanceof PeriodicTime && (this.task.schedule.duration == null))) {
                      return 'oneshot';
                  } else if(this.task.schedule instanceof PlayUntilTime || (this.task.schedule instanceof PeriodicTime && this.task.schedule.duration !== null)) {
                      return 'interval';
                  }
                  return 
              },
              set(newValue) {
                  let hourly = !(this.task.schedule instanceof DefaultSchedule) && (this.task.schedule instanceof PeriodicTime);
                  let defaultStart = this.task.schedule.start === undefined ? new DailyTime(0, 0) : this.task.schedule.start;
                  let defaultEnd = hourly ? new PeriodicTime(new DailyTime(23, 59)) : new DailyTime(23, 59)
                  switch(newValue){
                      case 'default':
                          this.task.schedule = new DefaultSchedule();
                          break;
                      case 'oneshot':
                            if(hourly) {
                                this.task.schedule.duration = null;
                            } else {
                              this.task.schedule = new PlayUntilCompleted(defaultStart);
                            }
                          break;
                      case 'interval':
                            if(hourly) {
                                this.task.schedule.duration = 10;
                            } else {
                          this.task.schedule = new PlayUntilTime(defaultStart, defaultEnd);
                            }
                          break;
                  }
              }
          },
          repeatMode: {
              get(){
                if(!(this.task instanceof Task)) return null;
                if(this.task.schedule instanceof DefaultSchedule) return null;
                if (this.task.schedule instanceof PeriodicTime){
                  /*
                  switch(this.task.schedule.repeat){
                    case 60:{
                        return 'hourly'
                    };
                    case 30:{
                        return 'halfHourly'
                    };
                    case 15:{
                        return 'quarterHourly'
                    };
                    case 10:{
                        return 'sixthPartHourtlyTime'
                    };
                    case 5:{
                        return 'twelfthPartHourtlyTime'
                    };
                  }
                  */
                  return 'periodic';
                }
                else if (this.task.schedule.start instanceof DailyTime){
                    return 'daily'
                }
              },
              set(newValue) {
                if(this.task.schedule instanceof DefaultSchedule) return null;
                let hasEnd = this.task.schedule instanceof PlayUntilTime;
                let duration = this.task.schedule instanceof PeriodicTime ? this.task.schedule.duration : (this.task.schedule instanceof PlayUntilTime ? 10 : 0);
                let start = this.task.schedule.start || new DailyTime(12, 0);
                switch(newValue) {
                case 'periodic':
                  this.task.schedule = new PeriodicTime(start, this.repeatRate || 60, duration);
                  break;
                /*
                  case 'hourly':
                    this.task.schedule = new PeriodicTime(new DailyTime(23, 59), 60, duration);
                    break;
                case 'halfHourly':
                    this.task.schedule = new PeriodicTime(new DailyTime(23, 59), 30, duration);
                    break;
                case 'quarterHourly':
                    this.task.schedule = new PeriodicTime(new DailyTime(23, 59), 15, duration);
                    break;
                case 'sixthPartHourtlyTime':
                    this.task.schedule = new PeriodicTime(new DailyTime(23, 59), 10, duration);
                    break;
                case 'twelfthPartHourtlyTime':
                    this.task.schedule = new PeriodicTime(new DailyTime(23, 59), 5, duration);
                    break;
                */
                case 'daily':
                    if(hasEnd) {
                        this.task.schedule = new PlayUntilTime(start, new DailyTime(23, 59));
                    } else {
                        this.task.schedule = new PlayUntilCompleted(start);
                    }
                    break;
                }
              }
          },
          repeatRate: {
            get(){
              if(this.task.schedule instanceof PeriodicTime){ return this.task.schedule.repeat; }
              return null;
            },
            set(value){
              if(this.task.schedule instanceof PeriodicTime){ this.task.schedule.repeat = Number(value); }
            }
          },
          startTime: {
              get() {
                  if(!(this.task instanceof Task)) return null;
                  if(this.task.schedule instanceof DefaultSchedule) return null;
                  return this.task.schedule.start.toString()
              },
              set(newValue) {
                  if(this.task.schedule instanceof DefaultSchedule) return null;
                  if(this.task.schedule instanceof PeriodicTime){
                    let [hour, minute] = newValue.split(':').map((it) => parseInt(it));
                      console.log(hour, minute)
                      if((minute > 59) || (minute < 0)){
                          this.startTimeIsInvalid = true;
                          return;
                      }
                      this.startTimeIsInvalid = false;
                      this.task.schedule.start = new DailyTime(hour, minute);
                  } else if(this.task.schedule.start instanceof DailyTime){
                      let [hour, minute] = newValue.split(':').map((it) => parseInt(it));
                      if((hour > 23) || (hour < 0) || (minute > 59) || (minute < 0)){
                          this.startTimeIsInvalid = true;
                          return;
                      }
                      this.startTimeIsInvalid = false;
                      this.task.schedule.start = new DailyTime(hour, minute);
                  }
              }
          },
          endTime: {
              get() {
                  if(!(this.task instanceof Task)) return null;
                  if(!(this.task.schedule instanceof PlayUntilTime)) return null;
                  return this.task.schedule.end.toString()
              },
              set(newValue) {
                  if(!(this.task.schedule instanceof PlayUntilTime)) return null;
                  let [hour, minute] = newValue.split(':').map((it) => parseInt(it));
                      this.task.schedule.end = new DailyTime({hour, minute});
                    if(this.task.schedule.end instanceof DailyTime){
                      let [hour, minute] = newValue.split(':').map((it) => parseInt(it));
                      if((hour > 23) || (hour < 0) || (minute > 59) || (minute < 0)){
                          return;
                      }
                      this.task.schedule.end = new DailyTime(hour, minute);
                  }
              }
          },
      }
  }
  </script>
  
  <style scoped>
  .select_time input, .select_time select {
      width: 100%;
      box-sizing: border-box;
      height: 40px;
      min-width: 165px;
  }
  .time_container {
      display: flex;
      align-content: flex-start;
      justify-content: flex-start;
  }
  .select_time {
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      color: #141414;
      padding: 10px;
      width: 26%;
  }
  .select_time select, .select_time input {
      width: 100%;
      box-sizing: border-box;
      padding: 5px;
      height: 40px;
  }
  .select_time span, .select_time div {
      font-size: 10pt;
      font-weight: bold;
      padding: 5px;
  }
  .is-invalid {
      border: 2px solid #F52;
  }
  @media screen and (max-width:768px) {
      .select_time{
          width: 34%;
      }
  }
  @media screen and (max-width:520px) {
      .select_time{
          width: 190px;
      }
  }
  @media screen and (max-width:400px) {
      .select_time{
          width: 170px;
      }
  }
  </style>
